import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M40-304q0-109 93-171t211-62q118 0 211 62t93 171H40Zm0 132v-68h608v68H40ZM70-40q-12.75 0-21.375-8.625T40-70v-38h608v38q0 12.75-8.625 21.375T618-40H70Zm638 0v-275q0-105.45-70.5-182.225Q567-574 463-595l-17-145h205v-180h60v180h209L852-94q-2.312 23.25-19.656 38.625Q815-40 792-40h-84Z"
  })
}), "FastfoodFilled");